import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_PAGES } from '@core/constants/app-pages.const';
import { IdleService } from '@core/services/idle.service';
import { AuthStore } from '@core/stores/auth.store';

/**
 * Guard kiểm tra người dùng đã đăng nhập chưa.
 * Dựa trên sự tồn tại của Token trong AuthStore.
 */
export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isLoggedIn()) {
    // Mở lại trang sau khi đã quá thời gian idle (tắt máy / đóng trình duyệt) → đăng xuất trước khi vào layout
    const idleService = inject(IdleService);
    if (idleService.hasExpired()) {
      idleService.endSession();
      return router.parseUrl('/' + APP_PAGES.LOGIN.path);
    }
    return true;
  }

  // Nếu chưa đăng nhập, chuyển hướng về trang login
  return router.parseUrl('/' + APP_PAGES.LOGIN.path);
};
